import { useRef } from "react";

import { joinSelectedChapters } from "@/data/chapter-range";
import type { TimelineSpan } from "@/data/join-chapters";
import type { CompiledChapter } from "@/data/schema/compiled";
import { journeyModel, type BookJourneyModel } from "@/pages/loadBookTimeline";

/** Each selection is built once, so going back to one is instant. */
export function useSelectedChapters(
  chapters: readonly CompiledChapter[],
  spans: readonly TimelineSpan[],
  spanId: string,
): BookJourneyModel {
  const built = useRef(new Map<string, BookJourneyModel>());
  const cached = built.current.get(spanId);
  if (cached !== undefined) {
    return cached;
  }
  const joined = joinSelectedChapters(chapters, spans, spanId);
  const model = journeyModel(joined.chapter, joined.spans, "book");
  built.current.set(spanId, model);
  return model;
}
